<div [id]="id" class="relative font-semibold text-white text-sm/6" [ngClass]="isSideMenu ? 'px-6 py-3' : ''">
  <button
    type="button"
    class="-m-1.5 flex items-center p-1.5 cursor-pointer"
    id="user-menu-button"
    (click)="isProfileOpen = !isProfileOpen"
    aria-haspopup="true"
  >
    <span class="sr-only">Open user menu</span>
    <img
      class="size-8 rounded-full bg-gray-50"
      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      alt=""
    />

    <span class="ml-3" [ngClass]="isSideMenu ? 'lg:block md:hidden block' : 'sm:block hidden'">
      {{ name }}
    </span>
  </button>

  @if (isProfileOpen) {
    <div
      @fadeInOut
      class="absolute z-50 w-30 origin-top-right rounded-md bg-white ring-1 shadow-lg ring-gray-900/5"
      role="menu"
      [ngClass]="isSideMenu ? 'bottom-full mb-1.5 mr-3 ' : 'mt-2.5 right-0'"
      aria-orientation="vertical"
      aria-labelledby="user-menu-button"
    >
      <button (click)="logout()" class="block px-3 py-3 text-sm text-gray-900 rounded-md cursor-pointer">Cerrar Sesión</button>
    </div>
  }
</div>
